module.exports = __webpack_public_path__ + "static/media/255px_logo_bug_tl.95729f37.png";